import PropTypes from 'prop-types';

import FloatingInput from '#/modules/commonComponents/form/FloatingInput';
import { Button } from '#/modules/commonComponents/button';
import { buildMtrNoFromSerialFormatter } from '#/modules/imsMgmt/settings/mtr/helper/buildMtrNoFromSerialFormatter';
import { parseSerialFormatter } from '#/modules/imsMgmt/settings/mtrTemplate/helper/serialFormatterSerialize';
import { toast } from '#/utils/toast';

const MtrNoSection = ({
  register,
  errors,
  watch,
  setValue,
  mtrTemplateId = '',
  templateDetail = null,
  treeRows = [],
  manufacturers = [],
  specDetailsById = {},
}) => {
  const formatterItems = parseSerialFormatter(templateDetail?.serialFormatter);
  const canGenerate = Boolean(mtrTemplateId) && formatterItems.length > 0;

  function handleGenerateMtrNo() {
    if (!mtrTemplateId) {
      toast.info('請先選擇模板');
      return;
    }

    if (formatterItems.length === 0) {
      toast.info('此模板未設定序號格式');
      return;
    }

    const formValues = watch?.() ?? {};
    const result = buildMtrNoFromSerialFormatter(
      templateDetail?.serialFormatter,
      formValues,
      {
        treeRows,
        manufacturers,
        specDetailsById,
      },
    );

    if (!result) {
      toast.info('無法組成料號，請確認分類、製造商與規格已填寫');
      return;
    }

    setValue('mtrNo', result, { shouldDirty: true, shouldValidate: true });
  }

  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-start">
      <Button
        type="button"
        size="sm"
        className="mt-3 shrink-0"
        disabled={!canGenerate}
        onClick={handleGenerateMtrNo}
      >
        生成料號
      </Button>
      <FloatingInput
        id="mtrNo"
        label="料號"
        containerClassName="min-w-0 flex-1"
        register={register}
        errors={errors}
      />
    </div>
  );
};

MtrNoSection.propTypes = {
  register: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  watch: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  mtrTemplateId: PropTypes.string,
  templateDetail: PropTypes.object,
  treeRows: PropTypes.arrayOf(PropTypes.object),
  manufacturers: PropTypes.arrayOf(PropTypes.object),
  specDetailsById: PropTypes.object,
};

export default MtrNoSection;
